import { apiClient } from '@/sdk/shared/apiClient';
import type { AdminDownloadsListResponse, AdminDownloadResponse } from './types';

export const adminDownloadsApi = {
  /**
   * Fetch all downloads (admin view)
   */
  getDownloads: async (): Promise<AdminDownloadsListResponse> => {
    return await apiClient.get<AdminDownloadsListResponse>('/admin/downloads');
  },

  /**
   * Create a new download record (supports FormData for file uploads)
   */
  createDownload: async (formData: FormData): Promise<AdminDownloadResponse> => {
    return await apiClient.post<AdminDownloadResponse>('/admin/downloads', formData);
  },

  /**
   * Update an existing download record (supports FormData for file uploads)
   */
  updateDownload: async (id: string, formData: FormData): Promise<AdminDownloadResponse> => {
    return await apiClient.put<AdminDownloadResponse>(`/admin/downloads/${id}`, formData);
  },

  /**
   * Delete a download record
   */
  deleteDownload: async (id: string): Promise<{ success: boolean; message: string }> => {
    return await apiClient.delete<{ success: boolean; message: string }>(`/admin/downloads/${id}`);
  }
};

export default adminDownloadsApi;
